export default IconBrandLinktree => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-brand-linktree" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M9 3l-7 12h3v5h5v-5h-2l4 -7z" />
  <path d="M15 3l7 12h-3v5h-5v-5h2l-4 -7z" />
</svg>`;